import { UserManagement } from 'components/UserManagement';
import { Page } from 'layouts/Page';
import { FC } from 'react';

export const UserManagementPage: FC = () => {
	return (
		<Page title="User management – EAS Dashboard">
			<UserManagement />
		</Page>
	);
};
